<div class="notification-dropdown-container">
  <!-- Bell Icon with Badge -->
  <div class="notification-trigger" (click)="onToggleDropdown()">
    <div class="bell-icon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM18 16V11C18 7.93 16.37 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.64 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16ZM16 17H8V11C8 8.52 9.51 6.5 12 6.5C14.49 6.5 16 8.52 16 11V17Z" fill="currentColor"/>
      </svg>
      <!-- Badge for unread count -->
      <div class="notification-badge" *ngIf="unreadCount > 0">
        <span>{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
      </div>
    </div>
  </div>

  <!-- Dropdown Panel -->
  <div class="notification-dropdown" [class.open]="isOpen">
    <div class="dropdown-header">
      <h4>Alerts & Notifications</h4>
      <button class="close-btn" (click)="onToggleDropdown()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/>
        </svg>
      </button>
    </div>

    <div class="dropdown-content">
      <!-- Alerts Section -->
      <div class="section" *ngIf="alerts.length > 0">
        <div class="section-header">
          <h5>Alerts</h5>
          <a class="view-all-link" (click)="navigateToAlertList()">View All</a>
        </div>
        <div class="alerts-list">
          <div class="alert-item" *ngFor="let alert of alerts">
            <div class="alert-content">
              <div class="alert-title">
                <a (click)="navigateToCabinet(alert.cabinet_id)" class="cabinet-link">{{ alert.cabinet_name }}</a>
                <a (click)="navigateToProduct(alert.cabinet_id)" class="product-link">{{ alert.product_name }}</a>
              </div>
              <div class="alert-meta">
                {{ alert.store_name }} | {{ timestampFormat(alert.raised_at, "DD/MM/YYYY") }}
              </div>
            </div>
            <div class="alert-status">
              <div class="status-badge" [class]="alert.status">
                <img *ngIf="alert.status === 'low stock'" src="../../../../assets/images/storelist/lowstock.svg" alt="Low Stock">
                <img *ngIf="alert.status === 'missing'" src="../../../../assets/images/storelist/missing.svg" alt="Missing">
                {{ alert.status }}
              </div>
              <div class="alert-count">{{ alert.count }}</div>
            </div>
            <div class="alert-action">
              <button class="mark-closed-btn" (click)="openDialog(alert)">
                <img src="../../../../assets/images/storelist/tickmark.svg" alt="Mark Closed">
                <span>Mark Closed</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Notifications Section -->
      <div class="section" *ngIf="notify.length > 0">
        <div class="section-header">
          <h5>Notifications</h5>
          <a class="view-all-link" (click)="navigateToNotifyList()">View All</a>
        </div>
        <div class="notifications-list">
          <div class="notification-item" *ngFor="let notification of notify">
            <div class="notification-content">
              <div class="notification-title">{{ notification.product_name }}</div>
              <div class="notification-shipment" *ngIf="notification.shipment_id">
                Shipment ID {{ notification.shipment_id }}
              </div>
              <div class="notification-meta">
                <ng-container *ngIf="notification.store_name">
                  {{ notification.store_name }} |
                </ng-container>
                Status:
                <span class="status-text" [class]="notification.status">
                  {{ notification.status }}
                </span>
              </div>
            </div>
            <div class="notification-date">
              {{ timestampFormat(notification.updated_at, "DD/MM/YYYY") }}
            </div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div class="empty-state" *ngIf="alerts.length === 0 && notify.length === 0">
        <div class="empty-icon">🔔</div>
        <p>No new alerts or notifications</p>
      </div>
    </div>
  </div>
</div> 